import { render, staticRenderFns } from "./info-item-modal.vue?vue&type=template&id=04549e33&"
import script from "./info-item-modal.vue?vue&type=script&lang=js&"
export * from "./info-item-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports